import { ClassName } from '@boxcryptor-web/shared/class-name';
import classnames from 'classnames';
import * as React from 'react';
import { overrideTailwindClasses } from 'tailwind-override';
import { focusRingClassNames, useNoFocusRingOnClick } from './general';

export const fontClassNames = 'text-gray-500';
export const fontWithHoverClassNames = `${fontClassNames} hover:text-gray-700 rounded-sm`;
export const fontWithHoverAndFocusClassNames = `${fontWithHoverClassNames} focus:text-gray-700`;
const disabledClassNames = `${fontClassNames} cursor-default text-gray-500`;

export const IconButton: React.FC<
  ClassName<{
    children?: React.ReactNode;
    icon: React.ReactNode;
    label?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
  }>
> = (props) => {
  const { icon, label, onClick, disabled, className, children } = props;
  const focusOutline = useNoFocusRingOnClick();

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={overrideTailwindClasses(
        classnames(
          'transition duration-150 inline-flex items-center justify-center space-x-1 p-1 focus:outline-none text-xl',
          disabled ? disabledClassNames : fontWithHoverAndFocusClassNames,
          focusOutline && focusRingClassNames,
          className
        )
      )}
    >
      {icon}
      {label && <div className="whitespace-nowrap text-sm">{label}</div>}
      {children && <div className="whitespace-nowrap text-sm">{children}</div>}
    </button>
  );
};

export const IconPseudoButton: React.FC<
  ClassName<{
    icon: React.ReactNode;
    label?: string;
    disabled?: boolean;
  }>
> = (props) => {
  const { icon, label, className, disabled } = props;

  return (
    <div
      className={overrideTailwindClasses(
        classnames(
          'transition duration-150 inline-flex items-center justify-center space-x-1 p-1 text-xl',
          'cursor-pointer',
          disabled ? disabledClassNames : fontWithHoverClassNames,
          className
        )
      )}
    >
      {icon}
      {label && <div className="whitespace-nowrap text-sm">{label}</div>}
    </div>
  );
};
